import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { computed, makeObservable, runInAction } from "mobx";
import ShadowMode from "terriajs-cesium/Source/Scene/ShadowMode";
function ShadowMixin(Base) {
  var _class;
  let ShadowMixin = (_class = class ShadowMixin extends Base {
    constructor() {
      super(...arguments);
      makeObservable(this);
    }
    get hasShadows() {
      return true;
    }
    get cesiumShadows() {
      switch (this.shadows.toLowerCase()) {
        case "none":
          return ShadowMode.DISABLED;
        case "both":
          return ShadowMode.ENABLED;
        case "cast":
          return ShadowMode.CAST_ONLY;
        case "receive":
          return ShadowMode.RECEIVE_ONLY;
        default:
          return ShadowMode.DISABLED;
      }
    }

    /** Shadow SelectableDimension. This has to be added to a catalog member's `selectableDimension` array */
    get shadowDimensions() {
      return [{
        id: "shadows",
        name: i18next.t("models.shadow.name"),
        options: [{
          id: "NONE",
          name: i18next.t("models.shadow.options.none")
        }, {
          id: "CAST",
          name: i18next.t("models.shadow.options.cast")
        }, {
          id: "RECEIVE",
          name: i18next.t("models.shadow.options.receive")
        }, {
          id: "BOTH",
          name: i18next.t("models.shadow.options.both")
        }],
        selectedId: this.shadows,
        disable: !this.showShadowUi,
        setDimensionValue: (strata, shadow) => shadow === "CAST" || shadow === "RECEIVE" || shadow === "BOTH" || shadow === "NONE" ? runInAction(() => this.setTrait(strata, "shadows", shadow)) : null
      }];
    }
  }, _applyDecoratedDescriptor(_class.prototype, "cesiumShadows", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cesiumShadows"), _class.prototype), _class);
  return ShadowMixin;
}
(function (_ShadowMixin) {
  function isMixedInto(model) {
    return model && model.hasShadows;
  }
  _ShadowMixin.isMixedInto = isMixedInto;
})(ShadowMixin || (ShadowMixin = {}));
export default ShadowMixin;